import styled from 'styled-components';

export const DisabledWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DisabledTooltipBubble = styled.div`
  position: absolute;
  bottom: calc(100% + 0.6rem);
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.6rem 0.75rem;
  border-radius: ${(p) => p.theme.borderRadius};
  width: 13rem;
  font-size: ${(p) => p.theme.fontSizeSm};
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  z-index: 1000;
  pointer-events: none;
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transition: opacity 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 0.4rem solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  @media only screen and (max-width: ${(p) => p.theme.breakpointSm}) {
    left: auto;
    right: 0;
    transform: none;

    &::after {
      left: auto;
      right: 1rem;
      transform: none;
    }
  }
`;

export const getSelectStyles = (theme) => ({
  container: (base) => ({
    ...base,
    width: '100%',
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? theme.grayLight : theme.white,
    border: `1.5px solid ${state.isDisabled ? theme.grayDark : theme.secondaryColorDark}`,
    borderRadius: theme.borderRadius,
    minHeight: '2.5rem',
    height: '2.5rem',
    width: '100%',
    fontSize: theme.fontSizeBase,
    boxShadow: 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {
      borderColor: state.isDisabled ? theme.disabledBg : theme.secondaryColor,
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 0.6rem',
    height: '100%',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '100%',
  }),
  option: (base, state) => ({
    ...base,
    display: 'block',
    textAlign: 'left',
    backgroundColor: state.isDisabled
      ? theme.white
      : state.isSelected || state.isFocused
        ? theme.bgColor
        : theme.white,
    color: state.isDisabled ? theme.gray : theme.black,
    fontSize: theme.fontSizeBase,
    padding: '0.4rem 0.6rem',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    fontStyle: state.isDisabled ? 'italic' : 'normal',
    '&:hover': {
      backgroundColor: state.isDisabled ? theme.white : theme.bgColor,
    },
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? theme.grayDark : theme.black,
    textAlign: 'left',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? theme.gray : base.color,
  }),
  menu: (base) => ({
    ...base,
    borderRadius: theme.borderRadius,
    border: `1.5px solid ${theme.grayDark}`,
    boxShadow: 'none',
  }),
});
